import React from 'react';
import { Button } from '@blueprintjs/core';
import { Suggest } from '@blueprintjs/select';
import { observable, action, toJS } from 'mobx';
import { observer, inject } from 'mobx-react';
import PropTypes from 'prop-types';
import { Api } from 'services/Api';
import axios from 'axios';
import debounce from 'services/debounce';
import { ProjectRenderer, ProjectListRenderer } from 'components/ProjectSuggest';

@inject('viewStore') @observer
class ProjectAutocomplete extends React.Component {

  @observable loading = true;
  @observable failed = false;
  @observable results = [];
  @observable selectedProject = null;

  componentDidMount() {
    let {
      selectedProjectId
    } = this.props;
    if (selectedProjectId) {
      let promise = Api.get(`/projects/${selectedProjectId}`)
      promise.then(response => {
        this.selectedProject = response.data.data;
      })
    }
  }

  @action
  onQueryChange(query) {
    this.failed = false;
    this.loading = true;
    if (query === '') {
      return;
    }
    let {
      props: {
        viewStore: {
          timesheetSearch
        }
      }
    } = this;
    let promise = Api.post('/projects/search', { search: {term: query, per_page: 50, page: 1, order: { name: 'asc' }, where: {...timesheetSearch.where} } })
    promise
      .then(this.onProjectsLoad.bind(this))
      .catch(this.onProjectsLoadFail.bind(this))
    return promise;
  }

  @action
  onProjectsLoadFail(error) {
    if (axios.isCancel(error)) {
      this.loading = true;
    } else {
      this.loading = false;
      this.failed = true;
    }
  }

  @action
  onProjectsLoad(response) {
    this.loading = false;
    this.failed = false;
    this.results = response.data.data;
  }

  @action
  onProjectSelect(project) {
    this.selectedProject = project;
    this.props.onProjectSelect(project);
  }

  @action
  clearSelectedProject() {
    this.props.viewStore.timesheetSearch.term = '';
    this.props.viewStore.timesheetSearch.where.project_id = '';
    this.selectedProject = null;
    this.props.onProjectSelect(null);
  }

  render() {
    let {
      failed,
      results,
      onQueryChange,
      loading,
      onProjectSelect,
      selectedProject,
      clearSelectedProject,
      props: {
        inputProps
      }
    } = this;
    return(
      <div className="client-name-field">
        {
          selectedProject ? <Button 
              text={
                this.selectedProject && this.selectedProject.attributes
                  ? `${this.selectedProject.attributes.number || ''} ${this.selectedProject.attributes.name || ''}`.trim()
                  : ''
              }
              rightIcon='cross'
              onClick={clearSelectedProject.bind(this)}
            /> : <Suggest
              inputProps={{
                icon: 'cross',
                placeholder: 'Search projects',
                ...inputProps
              }}
              closeOnSelect={true}
              openOnKeyDown={true}
              resetOnQuery={true}
              resetOnSelect={true}
              popoverProps={{ minimal: true }}
              onQueryChange={debounce(onQueryChange.bind(this)).bind(this)}
              items={toJS(results)}
              itemRenderer={ProjectRenderer}
              itemListRenderer={(props) => <ProjectListRenderer {...props} loading={loading} failed={failed} />}
              inputValueRenderer={(project) => project.attributes.name }
              onItemSelect={onProjectSelect.bind(this)}
            />
        }
      </div>
    )
  }
}

ProjectAutocomplete.propTypes = {
  inputProps: PropTypes.object,
  onProjectSelect: PropTypes.func.isRequired
}

export default ProjectAutocomplete;